import React from 'react'
import { unSlugify } from '../../utils'

const PenaltyTypePill = ({type}) => {
  return (
    <span className={`inline-block text-xs px-2 py-1 rounded 
        ${type === 'other' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
        ${type === 'suspenson' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
        ${type === 'probation' && 'bg-amber-600 text-amber-800 bg-opacity-10 font-outfit capitalize'}
        ${type === 'expulsion' && 'bg-red-600 text-red-800 bg-opacity-10 font-outfit capitalize'}
        ${type === 'detention' && 'bg-blue-600 text-blue-800 bg-opacity-10 font-outfit capitalize'}
        ${type === 'fine' && 'bg-purple-600 text-purple-800 bg-opacity-10 font-outfit capitalize'}
        `}>{unSlugify(type?.toLowerCase())}</span>
  )
}

export default PenaltyTypePill